import SectionMain from './Component';

export default SectionMain;